import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { forwardRef } from 'react';
import { themed } from '@indeed/ifl-css';
import { useDialogContext } from './context.js';
import { dialogSizes } from './constants.js';
import { jsx } from '@emotion/react';
import { Popup } from '../Popup/Popup.js';
import '@indeed/ihl-use-id';
import '../../hooks/useControllableState.js';
import '../../utils/warn.js';
import '../../hooks/useIsMobile.js';
import '../../hooks/useWindowSize.js';
import '../../hooks/useIsomorphicLayoutEffect.js';
import '../../hooks/useResponsiveValue.js';
import '../../hooks/useBreakpointIndex.js';
import '@floating-ui/react-dom';
import '../../hooks/useMergeRefs.js';
import '../Box/Box.js';

const baseStyles = _ref => {
  let {
    isFullScreen,
    isMobile,
    size,
    type
  } = _ref;
  const customCSSProps = [];
  if (!isFullScreen && isMobile) {
    customCSSProps.push({
      borderStartStartRadius: "lg"
    });
    customCSSProps.push({
      borderStartEndRadius: "lg"
    });
  }
  return {
    boxShadow: isMobile && type === "popup" ? "mobilePopover" : "none",
    backgroundColor: "background",
    border: isFullScreen || isMobile ? "none" : "1px solid",
    borderColor: "border.weak",
    borderRadius: isFullScreen || isMobile ? 0 : "lg",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    blockSize: isFullScreen ? "100%" : "auto",
    maxInlineSize: isFullScreen || isMobile ? "none" : dialogSizes[size],
    maxBlockSize: "100%",
    overflow: "hidden",
    paddingBlockEnd: isMobile ? 5 : 0,
    paddingBlockStart: 0,
    paddingInlineEnd: 0,
    paddingInlineStart: 0,
    position: "relative",
    inlineSize: "100%",
    zIndex: 2,
    "@media screen and (max-height: 32rem)": {
      overflow: "auto"
    },
    ":focus-visible": {
      outline: "none",
      boxShadow: _ref2 => {
        let {
          shadows
        } = _ref2;
        return [shadows.focus["[base]"], isMobile && type === "popup" ? shadows.mobilePopover : null].filter(x => x).join(", ");
      }
    },
    ...Object.assign({}, ...customCSSProps)
  };
};
const styleProps = new Set(["isFullScreen", "isMobile", "size", "type"]);
const StyledDialog = /*#__PURE__*/themed("div", process.env.NODE_ENV === "production" ? {
  styleProps: Array.from(styleProps),
  shouldForwardProp: prop => !styleProps.has(prop),
  target: "e1rjvi010"
} : {
  styleProps: Array.from(styleProps),
  shouldForwardProp: prop => !styleProps.has(prop),
  target: "e1rjvi010",
  label: "StyledDialog"
})(baseStyles, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const PopupStyledDialog = /*#__PURE__*/forwardRef((_ref3, forwardedRef) => {
  let {
    isFullScreen: _isFullScreen,
    isMobile: _isMobile,
    size: _size,
    type: _type,
    ...props
  } = _ref3;
  const {
    popupProps
  } = useDialogContext();
  const {
    sx,
    ...otherPopupProps
  } = popupProps;
  return jsx(Popup, _extends({
    ref: forwardedRef,
    showArrow: true,
    sx: {
      borderColor: "border.weak",
      borderRadius: "lg",
      variant: "text.level3",
      minInlineSize: "200px",
      maxInlineSize: "400px",
      zIndex: 2,
      ":focus-visible": {
        outline: "none",
        boxShadow: _ref4 => {
          let {
            shadows
          } = _ref4;
          return [shadows.focus["[base]"], shadows.medium].join(", ");
        }
      },
      ...sx
    }
  }, otherPopupProps, props));
});
const DialogBase = /*#__PURE__*/forwardRef((_ref5, forwardedRef) => {
  let {
    role,
    ...remainingProps
  } = _ref5;
  const {
    hasDescription,
    id,
    isFullScreen,
    isMobile,
    size,
    type
  } = useDialogContext();
  const C = type === "popup" && !isMobile ? PopupStyledDialog : StyledDialog;
  return jsx(C, _extends({
    role: role
  }, remainingProps, hasDescription ? {
    "aria-describedby": `dialog-description-${id}`
  } : null, {
    "aria-labelledby": `dialog-title-${id}`,
    "aria-modal": true,
    isFullScreen: isFullScreen,
    isMobile: isMobile,
    ref: forwardedRef,
    size: size,
    type: type
  }));
});
DialogBase.displayName = "DialogBase";

export { DialogBase, StyledDialog };
